
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TicketCreateCheckbox extends Vue {
  @Prop({ required: true }) value!: string | null;
  @Prop({ default: false }) enabled!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  get todayISO() {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  }
  get inputStyle() {
    return { width: "135px", display: "inline-block", margin: "0 2px" };
  }
  get dateModel(): string {
    return this.value ? this.value.slice(0, 10) : "";
  }
  set dateModel(val: string) {
    const norm = val ? val.slice(0, 10) : null;
    this.$emit("input", norm);
    this.$emit("update:value", norm);
    if (norm && !this.enabled) this.$emit("update:enabled", true);
  }
}
